import gsap, { Power3 } from "gsap";
import InterfaceCanvas from "../_app/cuchillo/layout/InterfaceCanvas";
import { Maths } from "../_app/cuchillo/utils/Maths";
import { Sizes } from "../_app/cuchillo/core/Sizes";
import { Metrics } from "../_app/cuchillo/core/Metrics";
import { isMobile } from "../_app/cuchillo/core/Basics";

export default class Background {
    static offset = { x: 0, y: -1 };
    static target = { x: 0, y: -1 };
    static lerpSpeed = { x: .025, y: .04 };

    static progressX = 0;
    static progressY = 0;

    static layers = [
        { size: 30, alpha: 0.3 },
        { size: 10, alpha: 0.1 }
    ];

    static container = InterfaceCanvas.canvas;
    static ctx = InterfaceCanvas.ctx;
    static width;
    static height;

    static initialized = false;

    static init() {
        this.loop();
    }

    static show(__cb = () => { }) {
        gsap.to(this, {
            progressY: 1,
            duration: 1.5,
            ease: Power3.easeOut
        });

        gsap.to(this, {
            progressX: 1,
            duration: 2,
            delay: .25,
            ease: Power3.easeOut,
            onComplete: () => {
                __cb();
                this.initialized = true;
            }
        });
    }

    static draw() {
        this.ctx.clearRect(0, 0, this.width, this.height);

        for (const { size, alpha } of this.layers) {
            this.ctx.save();
            this.ctx.strokeStyle = `rgba(0, 0, 0, ${alpha})`;
            this.ctx.lineWidth = Sizes.RATIO;
            this.ctx.beginPath();

            const step = size * Sizes.RATIO;
            const lineHeight = this.height * this.progressY;

            // let i = 0;
            for (let x = this.offset.x % step + 1; x <= this.width + step; x += step) {
                this.ctx.moveTo(x, 0);
                this.ctx.lineTo(x, lineHeight);

                // console.log('X', i);
                // i++;
            }

            const lineWidth = this.width * this.progressX;
            for (let y = this.offset.y % step + 1; y <= this.height + step * 2; y += step) {
                this.ctx.moveTo(0, y);
                this.ctx.lineTo(lineWidth, y);
            }

            this.ctx.stroke();
            this.ctx.restore();
        }
    }

    static loop() {
        // this.offset.x = Maths.lerp(this.offset.x, this.target.x, this.lerpSpeed.x);
        // this.offset.y = Maths.lerp(this.offset.y, this.target.y, this.lerpSpeed.y);

        if (this.initialized) return;

        this.draw();
    }

    static directGoto({ x, y }) {
        // this.offset.x = this.target.x = x;
        // this.offset.y = this.target.y = y;
    }

    static goto({ x, y }) {
        // this.target.x = x;
        // this.target.y = y;
    }

    static resize() {
        this.width = this.container.offsetWidth * Sizes.RATIO;
        this.height = this.container.offsetHeight * Sizes.RATIO;


        // this.layers[0].size = isMobile ? Metrics.parseSize('12fpx') : Metrics.parseSize('6.2fpx');
        // this.layers[1].size = isMobile ? Metrics.parseSize('4fpx') : Metrics.parseSize('5.3fpx');
        this.layers[0].size = isMobile ? Metrics.parseSize('15fpx') : Metrics.parseSize('30fpx');
        this.layers[1].size = isMobile ? Metrics.parseSize('5fpx') : Metrics.parseSize('10fpx');

        this.draw();
    }
}